<section role="region" class="homeB-employer-engagement">
  <div class="homeB-employer-engagement__content">
    <header role="banner" class="homeB-employer-engagement__content__header">
      <h2 role="heading" class="homeB-employer-engagement__content__header__title">
        <span class="highlight--emphasis">Je rejoins la mobilisation pour l&apos;emploi des jeunes&nbsp;!</span>
      </h2>
    </header>
    <p class="homeB-employer-engagement__content__text">
      Votre entreprise recrute ou porte une initiative pour l&apos;emploi des jeunes&nbsp;?
    </p>
    <p>
      Rejoignez la mobilisation
      <strong>&ldquo;Les entreprises s&apos;engagent.&rdquo;</strong>
    </p>
    <footer class="homeB-employer-engagement__content__footer">
      <a
        [routerLink]="['/', FeaturesRoutingEnum.Companies, CompaniesRoutingEnum.Register]"
        class="btn companies__btn"
        (click)="trackEvent({ category: 'Home', action: 'Click Mobilisation', type: 'navigation', label: 'Bouton' })"
        >Rejoindre la mobilisation</a
      >
      <app-tooltip>
        <div class="homeB-employer-engagement__container-tooltip">
          <p class="homeB-employer-engagement__container-tooltip__title">Quels avantages&nbsp;?</p>
          <ul>
            <li>Mettez en avant tous vos engagements pour les jeunes en créant votre page dédiée</li>
            <li>Publiez vos offres d&apos;emploi sur la plateforme</li>
            <li>Bénéficiez d&apos;un accompagnement par un Conseiller Pôle Emploi (rappel sous 72&nbsp;H)</li>
            <li>Relayez vos engagements par l&apos;intermédiaire d&apos;un kit de communication #1jeune1solution</li>
          </ul>
        </div>
      </app-tooltip>
    </footer>
  </div>
  <ng-container *ngIf="(isMobileOrTablet$ | async) === false">
    <div class="homeB-employer-engagement__illustration">
      <img [src]="illustrationSrc | imaginarySrc: 1:386" [srcset]="illustrationSrc | imaginarySrc: 4:386" alt="" />
    </div>
  </ng-container>
</section>
